<div [ngClass]="theme.getThemeClass()" class="table-container width100">
  @if (view.loading) {
  <div class="table-loading-placeholder">
    <div class="loader"></div>
  </div>
  } @else {
  <article class="table-responsive minMarginBotton">
    <table class="table table-hover">
      <thead>
        <tr>
          <th [ngClass]="theme.getThemeClass()">
            {{ "iotTabHeaderDevice" | translate }}
          </th>
          <th [ngClass]="theme.getThemeClass()">{{ "version" | translate }}</th>
          <th [ngClass]="theme.getThemeClass()">
            {{ "deviceConfigModalDistance" | translate }}
          </th>
          <th [ngClass]="theme.getThemeClass()">
            {{ "temperature" | translate }}
          </th>
          <th [ngClass]="theme.getThemeClass()">VB1</th>
          <th [ngClass]="theme.getThemeClass()">
            {{ "iotModalHeaderBattery" | translate }}
          </th>
          <th [ngClass]="theme.getThemeClass()">{{ "VCC" | translate }}</th>
          <th [ngClass]="theme.getThemeClass()">{{ "oper" | translate }}</th>
          <th [ngClass]="theme.getThemeClass()">{{ "signal" | translate }}</th>
          <th [ngClass]="theme.getThemeClass()">NCT</th>
          <th [ngClass]="theme.getThemeClass()">{{ "state" | translate }}</th>
          <!-- <th [ngClass]="theme.getThemeClass()">
            {{ "iotTabHeaderStatus" | translate }}
          </th> -->
          <th [ngClass]="theme.getThemeClass()">
            {{ "iotTabHeaderLastActivity" | translate }}
          </th>
          <th [ngClass]="theme.getThemeClass()">
            {{ "iotTabHeaderResources" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (deviceRow of view.filteredDevices(); track deviceRow.thingName;
        let i = $index) {
        <tr class="device-table-row">
          <td [ngClass]="theme.getThemeClass()">{{ deviceRow.thingName }}</td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.fdv) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.dst) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.tm2) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.vb1) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.bat) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.vcc) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.car.oper) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.sig) }}
          </td>
          <td [ngClass]="theme.getThemeClass()">
            {{ formatNumber(deviceRow.dat.nct) }}
          </td>
          <td
            [ngClass]="theme.getThemeClass()"
            class="light-td"
            (mouseover)="setStateInfo(i, true)"
            (mouseleave)="setStateInfo(i, false)"
          >
            <div class="trafic-light-box">
              <div class="traffic-light">
                <div
                  class="light"
                  [ngClass]="{
                    'light-green':
                      deviceRow.heartbeat &&
                      deviceRow.heartbeat.color === 'green',
                    'light-yellow':
                      deviceRow.heartbeat &&
                      deviceRow.heartbeat.color === 'yellow',
                    'light-red':
                      deviceRow.heartbeat && deviceRow.heartbeat.color === 'red'
                  }"
                ></div>
              </div>
              @if (showStateInfo[i]) {
              <div class="info-state-box" [ngClass]="theme.getThemeClass()">
                <div class="state-info-layer">
                  <label class="state-title">
                    {{ "beatMiss" | translate }} :
                  </label>
                  <label class="state-info">
                    @if
                    (this.iotService.isBeatMissMoreThenOneHundred(deviceRow.heartbeat?.beat_miss))
                    {<span>+</span>}
                    {{ deviceRow.heartbeat?.beat_miss || 0 }}
                  </label>
                </div>
                <div>
                  <label class="state-title">
                    {{ "suposeToCommunicate" | translate }} :
                  </label>
                  <label class="state-info">
                    {{ deviceRow.heartbeat?.supposed_to_communicate }}
                  </label>
                </div>
                <div>
                  <label class="state-title">
                    {{ "sleepTimeConfig" | translate }} :
                  </label>
                  <label class="state-info">
                    {{
                      this.iotService.convertSecondToHour(deviceRow.config?.slp)
                        | translate
                    }}
                  </label>
                </div>
              </div>
              }
            </div>
          </td>
          <!-- <td [ngClass]="theme.getThemeClass()">
            {{ verifyStatus(deviceRow.thingName) | translate }}
          </td> -->
          <td [ngClass]="theme.getThemeClass()">{{ deviceRow.date }}</td>
          <td [ngClass]="theme.getThemeClass()">
            <div class="divButton">
              <!-- Show device configs modal -->
              <a
                href="javascript:void(0)"
                (click)="this.iotService.showConfig(deviceRow.thingName)"
                [class.disabled]="this.iotService.cognitoService.userType !== 'muirwood'"
              >
                <img
                  [title]="'iotModalViewConfig' | translate"
                  class="iconParam"
                  src="./assets/settings.png"
                  alt="icon of param"
                  height="20"
                  width="20"
                  style="color: gray"
                />
              </a>
              <!-- Show device notes modal -->
              <a
                href="javascript:void(0)"
                (click)="
                  this.showDeviceNotes(deviceRow.thingName);
                  this.modal.showNotes(deviceRow.thingName)
                "
              >
                <i class="fa-solid fa-file-pen note-icon"></i>
              </a>
              <!-- Show device shadow modal -->
              <a
                href="javascript:void(0)"
                (click)="
                  this.modal.showShadow(
                    this.iotService.getDeviceShadow(deviceRow.thingName),
                    deviceRow.thingName
                  )
                "
              >
                <img
                  [title]="'shadow' | translate"
                  class="iconParam"
                  src="./assets/json-icon.png"
                  alt="icon of json"
                  height="20"
                  width="20"
                  style="color: gray"
                />
              </a>
              <!-- Download device certificate -->
              <a
                href="javascript:void(0)"
                (click)="this.getCertificateFolderUrl(deviceRow.thingName)"
              >
                <img
                  [title]="'generateCertificate' | translate"
                  class="iconCert"
                  src="./assets/grey-certificate-48.png"
                  alt="icon of certificate"
                  height="25"
                  width="25"
                  style="color: gray"
                />
              </a>
              <!-- Show device association modal -->
              <a
                href="javascript:void(0)"
                (click)="this.showRelation(deviceRow.thingName)"
              >
                <img
                  [title]="'deviceRelationship' | translate"
                  class="iconCert"
                  src="./assets/relationship.png"
                  alt="icon of relationship"
                  height="25"
                  width="25"
                  style="color: gray"
                />
              </a>
              <!-- Send user to device statistic page -->
              <a (click)="setNavToDeviceStat(deviceRow.thingName)">
                <img
                  [title]="'showReports' | translate"
                  class="iconStat"
                  src="./assets/bar-chart-48.png"
                  alt="icon of a chart"
                  height="25"
                  width="25"
                  style="color: gray"
                />
              </a>
              <!-- Send user to graphs page -->
              <a
                href="javascript:void(0)"
                (click)="
                  this.iotService.showTechnicalGraphs(deviceRow.thingName)
                "
                [ngClass]="
                  this.iotService.showDeviceTechnicalGraphs ? 'disabled' : ' '
                "
              >
                <i class="fa-solid fa-chart-line"></i>
              </a>
              <!-- Show delete device modal -->
              <a
                href="javascript:void(0)"
                (click)="
                  this.modal.showDeviceModal = true;
                  this.iotService.ShowDeleteThingModal(deviceRow.thingName)
                "
              >
                <i class="fa-solid fa-trash delete-device"></i>
              </a>
              <!-- Show modal to reset device and his data to initial values -->
              <a
                href="javascript:void(0)"
                (click)="initializeDeviceForProduction(deviceRow.thingName)"
              >
                <i
                  [title]="'initializeDeviceIcon' | translate"
                  class="fa-solid fa-arrows-rotate refresh-device"
                ></i>
              </a>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </article>
  }
</div>
